import { ref } from 'vue'

export const showConditionUseModalBus = ref(false)
